import Hero, { HERO_FRAGMENT } from '../../components/Hero';
import fetchGql, { gql } from '../../util/fetchGql';
import Seo, { SEO_FRAGMENT } from '../../components/Seo';
import Products, {
	PRODUCTS_QUERY,
	PRODUCTS_QUERY_FRAGMENT
} from '../../components/Products';
import { FILTER_QUERY } from '../../components/Filter';
import { useRouter } from 'next/router';

export default function ProductCategory ({ entry: { seo, hero }, products, filter }) {
	const { asPath } = useRouter();

	return (
		<>
			<Seo seo={seo} />
			<Hero {...hero[0]} />
			<Products
				key={asPath}
				products={products}
				filter={filter}
				hideCategories
			/>
		</>
	);
}

export async function getStaticProps (ctx) {
	const slug = ctx.params.slug;
	const data = await fetchGql(gql`
        query ProductCategory ($slug: String) {
            entry (slug: [$slug]) {
                ...on productCategory_default_Entry {
                    id
                    seo { ...Seo }
                    hero: banner { ...Hero }
                    filterSettings {
                        ... on filterSettings_BlockType {
                            showBrands
                            showCondition
                            showPaymentOptions
                            showPrices
                        }
                    }
                    children {
                        id
                    }
                }
            }
        }
        ${SEO_FRAGMENT}
        ${HERO_FRAGMENT}
	`, {
		slug,
		brand: [],
		category: [slug],
	}, ctx);

	if (!data.entry)
		return { notFound: true };

	return {
		props: {
			...data,
			products: (await fetchGql(PRODUCTS_QUERY, { brand: null, category: slug }, ctx))?.products ?? [],
			filter: await fetchGql(FILTER_QUERY, null, ctx),
		}
	};
}

export async function getStaticPaths () {
	const data = await fetchGql(gql`{
        entries (section: "productCategory") {
            slug
        }
    }`);

	return {
		paths: data?.entries?.map?.(e => ({ params: e })) ?? [],
		fallback: 'blocking',
	};
}
